'use strict';

var _require = require('./abstractPerson'),
    AbstractPersonSchema = _require.AbstractPersonSchema;

var _require2 = require('./appRole'),
    AppRoleSchema = _require2.AppRoleSchema;

var _require3 = require('./appUser'),
    AppUserSchema = _require3.AppUserSchema;

var _require4 = require('./baseProperties'),
    BasePropertiesSchema = _require4.BasePropertiesSchema;

var _require5 = require('./dateiupload'),
    DateiuploadSchema = _require5.DateiuploadSchema;

var _require6 = require('./externeOrganisation'),
    ExterneOrganisationSchema = _require6.ExterneOrganisationSchema;

var _require7 = require('./foerderung'),
    FoerderungSchema = _require7.FoerderungSchema;

var _require8 = require('./forschungsbericht'),
    ForschungsberichtSchema = _require8.ForschungsberichtSchema;

var _require9 = require('./forschungsprojekt'),
    ForschungsprojektSchema = _require9.ForschungsprojektSchema;

var _require10 = require('./kooperation'),
    KooperationSchema = _require10.KooperationSchema;

var _require11 = require('./land'),
    LandSchema = _require11.LandSchema;

var _require12 = require('./mittelgeber'),
    MittelgeberSchema = _require12.MittelgeberSchema;

var _require13 = require('./nachwuchsfoerderung'),
    NachwuchsfoerderungSchema = _require13.NachwuchsfoerderungSchema;

var _require14 = require('./orgaIdent'),
    OrgaIdentSchema = _require14.OrgaIdentSchema;

var _require15 = require('./organisationseinheit'),
    OrganisationseinheitSchema = _require15.OrganisationseinheitSchema;

var _require16 = require('./patent'),
    PatentSchema = _require16.PatentSchema;

var _require17 = require('./patentanzahl'),
    PatentanzahlSchema = _require17.PatentanzahlSchema;

var _require18 = require('./person'),
    PersonSchema = _require18.PersonSchema;

var _require19 = require('./personIdent'),
    PersonIdentSchema = _require19.PersonIdentSchema;

var _require20 = require('./personIdentTyp'),
    PersonIdentTypSchema = _require20.PersonIdentTypSchema;

var _require21 = require('./preis'),
    PreisSchema = _require21.PreisSchema;

var _require22 = require('./preisBezeichnung'),
    PreisBezeichnungSchema = _require22.PreisBezeichnungSchema;

var _require23 = require('./projektleiter'),
    ProjektleiterSchema = _require23.ProjektleiterSchema;

var _require24 = require('./promotionsprogrammtyp'),
    PromotionsprogrammtypSchema = _require24.PromotionsprogrammtypSchema;

var _require25 = require('./pubIdent'),
    PubIdentSchema = _require25.PubIdentSchema;

var _require26 = require('./pubIdentTyp'),
    PubIdentTypSchema = _require26.PubIdentTypSchema;

var _require27 = require('./publikation'),
    PublikationSchema = _require27.PublikationSchema;

var _require28 = require('./publikationsupload'),
    PublikationsuploadSchema = _require28.PublikationsuploadSchema;

var _require29 = require('./strukturiertesPromotionsprogramm'),
    StrukturiertesPromotionsprogrammSchema = _require29.StrukturiertesPromotionsprogrammSchema;

var _require30 = require('./veranstaltung'),
    VeranstaltungSchema = _require30.VeranstaltungSchema;

module.exports = {
  AbstractPersonSchema: AbstractPersonSchema,
  AppRoleSchema: AppRoleSchema,
  AppUserSchema: AppUserSchema,
  BasePropertiesSchema: BasePropertiesSchema,
  DateiuploadSchema: DateiuploadSchema,
  ExterneOrganisationSchema: ExterneOrganisationSchema,
  FoerderungSchema: FoerderungSchema,
  ForschungsberichtSchema: ForschungsberichtSchema,
  ForschungsprojektSchema: ForschungsprojektSchema,
  KooperationSchema: KooperationSchema,
  LandSchema: LandSchema,
  MittelgeberSchema: MittelgeberSchema,
  NachwuchsfoerderungSchema: NachwuchsfoerderungSchema,
  OrgaIdentSchema: OrgaIdentSchema,
  OrganisationseinheitSchema: OrganisationseinheitSchema,
  PatentSchema: PatentSchema,
  PatentanzahlSchema: PatentanzahlSchema,
  PersonSchema: PersonSchema,
  PersonIdentSchema: PersonIdentSchema,
  PersonIdentTypSchema: PersonIdentTypSchema,
  PreisSchema: PreisSchema,
  PreisBezeichnungSchema: PreisBezeichnungSchema,
  ProjektleiterSchema: ProjektleiterSchema,
  PromotionsprogrammtypSchema: PromotionsprogrammtypSchema,
  PubIdentSchema: PubIdentSchema,
  PubIdentTypSchema: PubIdentTypSchema,
  PublikationSchema: PublikationSchema,
  PublikationsuploadSchema: PublikationsuploadSchema,
  StrukturiertesPromotionsprogrammSchema: StrukturiertesPromotionsprogrammSchema,
  VeranstaltungSchema: VeranstaltungSchema
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/schema/index.js
// module id = edMz
// module chunks = 0